// extracted by mini-css-extract-plugin
export default {"AppWrapper":"styles_AppWrapper__LFEda"};